import { isEmail } from 'validator';

export const emailValidator = (value: string): string => {
  const regex = /^[A-Za-z0-9._+\-=@]+$/;
  if (!isEmail(value) || !regex.test(value)) {
    return 'Please provide a valid email address';
  }
  return '';
};
